import React, { useEffect, useState } from 'react'
import Box from '@mui/material/Box'
import axios from 'axios'
import Modal from '@mui/material/Modal'
import Typography from '@mui/material/Typography'
import Button from '@mui/material/Button'
import Snackbar from '@mui/material/Snackbar'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'
import Sidebar from '../sidebar'
import { MDBDataTable } from 'mdbreact'
import { Col, Row } from 'react-bootstrap'
import Checkbox from '@mui/material/Checkbox'
import { toast } from 'react-toastify'
import NavLogo from '../NavLogo'
import {
  DocumentFindForAdminApi,
  DocumentFindOneApi,
  ImagePath,
  MemberAdminApprovalApi,
  MemberAdminViewApi,
  MemberApprovalApi,
} from '../../ApiFile'
import MobileNavbarAdmin from './MobileNavbarAdmin'

import logo from '../../studentDashboard/img/logo2.png'
import logo2 from '../../studentDashboard/img/logonew.jpg'
import studentPhoto from '../../studentDashboard/img/StudentPic.png'
import parentsPhoto from '../../studentDashboard/img/ParentsPhoto.png'
import pdfMake from 'pdfmake/build/pdfmake'
import pdfFonts from 'pdfmake/build/vfs_fonts'

export default function Reg50Approval() {
  const [rows, setRows] = useState([])
  const [open, setOpen] = useState(false)
  const [selectedRow, setSelectedRow] = useState([])
  const [selectedRowId, setSelectedRowId] = useState(null)
  const [selectedPayType, setSelectedPayType] = useState(null)
  const [alertOpen, setAlertOpen] = useState(false)
  const [dialogOpen, setDialogOpen] = useState(false)
  const [statusModalOpen, setStatusModalOpen] = useState(false)
  const [statusRow, setStatusRow] = useState(null)
  const [rowToDelete, setRowToDelete] = useState(null)
  const [checkBoxChecked, setCheckBoxChecked] = useState(false)
  const [buttonFlag, setButtonFlag] = useState('')

  let flag = Number(sessionStorage.getItem('flag'))
  const handleCheckBoxChange = () => {
    setCheckBoxChecked(!checkBoxChecked)
  }

  function capitalizeWords(str) {
    return str.replace(/_/g, ' ').replace(/\b\w/g, (char) => char.toUpperCase())
  }

  const fetchData = () => {
    axios
      .get(MemberApprovalApi)
      .then((response) => {
        const mappedRows = response.data.map((row, index) => ({
          ...row,
          Name: row.name,
          PayAmount: row.pay_amount,
        }))
        setRows(mappedRows)
      })
      .catch((error) => {
        // console.error(error);
      })
  }

  useEffect(() => {
    fetchData()
  }, [])

  const handleApproval = (id) => {
    if (!checkBoxChecked) {
      alert('Please select the checkbox before proceeding.')
      return
    }

    const approvalData = {
      reg_id: id,
      status: 1, // Flag for approva
    }

    axios
      .put(MemberAdminApprovalApi, approvalData)
      .then((res) => {
        if (res.data == 'APPROVAL') {
          toast.success('Approved Successfully..!', {
            position: 'top-right',
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          })

          setCheckBoxChecked('')
          fetchData()
          setStatusModalOpen(false)
          setOpen(false)
        }
      })
      .catch((err) => {
        // console.error("Failed to save data:", err);
        toast.error('Failed...', {
          position: 'top-right',
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        })
      })
  }

  const handleDelete = (id) => {
    if (!checkBoxChecked) {
      // Display toast or alert when checkbox is not checked
      alert('Please select the checkbox before proceeding.')
      return
    }

    const rejectionData = {
      reg_id: id,
      status: 2,
    }

    axios
      .put(MemberAdminApprovalApi, rejectionData)
      .then((res) => {
        setDialogOpen(false)
        if (res.data === 'REJECT') {
          toast.success('Rejected Successfully..!', {
            position: 'top-right',
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          })
          setStatusModalOpen(false)
          setCheckBoxChecked('')
          fetchData() // Refresh data after rejection
          setOpen(false)
        }
      })
      .catch((err) => {
        // console.error("Failed to save data:", err);
        toast.error('Failed...', {
          position: 'top-right',
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        })
      })
  }

  const handleViewClick = (row) => {
    // setSelectedRow(row || {})
    setOpen(true)

    axios
      .get(`${MemberAdminViewApi}/${row.reg_id}`)
      .then((response) => {
        setSelectedRow(response.data)
      })
      .catch((error) => {
        // console.error(error);
      })
  }

  pdfMake.vfs = pdfFonts.pdfMake.vfs

  const toDataURL = (url) =>
    fetch(url)
      .then((response) => response.blob())
      .then(
        (blob) =>
          new Promise((resolve, reject) => {
            const reader = new FileReader()
            reader.onloadend = () => resolve(reader.result)
            reader.onerror = reject
            reader.readAsDataURL(blob)
          }),
      )
  let pdfToastId = null

  const generatePDF = async (regId) => {
    pdfToastId = toast.info('Please wait, generating PDF...', {
      autoClose: false,
      toastId: 'pdf-wait',
    })

    try {
      // Convert your logos + static placeholders
      const [
        logoBase64,
        logo2Base64,
        studentStaticBase64,
        parentStaticBase64,
      ] = await Promise.all([
        toDataURL(logo),
        toDataURL(logo2),
        toDataURL(studentPhoto), // 🔥 your static student img
        toDataURL(parentsPhoto), // 🔥 your static parent img
      ])

      // const res = await axios.get(`${DocumentFindOneApi}/${regId}`)
      // const data = res.data
      const [pdfRes, adminRes] = await Promise.all([
        axios.get(`${DocumentFindOneApi}/${regId}`),
        axios.get(
          `${DocumentFindForAdminApi}/${regId}`,
        ),
      ])

      const data = pdfRes.data
      const adminData = adminRes.data

      if (!data || !adminData) {
        throw new Error('No data found for PDF')
      }

      toast.dismiss('pdf-wait')

      const documentDefinition = {
        content: [
          {
            columns: [
              { style: 'logo', width: '15%', image: logoBase64, fit: [50, 50] },
              {
                width: '70%',
                text: [
                  { text: "Dakshin Bharat Jain Sabha's \n", style: 'header1' },
                  {
                    text: 'Sheth R D Dawada Digambar Jain Boarding,\n',
                    style: 'header',
                  },
                  {
                    text:
                      '37, Mahavir Nagar, Sangli 416416, Phone: 0233-262306\n',
                    style: 'header2',
                  },
                  {
                    text:
                      'Web : www.jainboardingsangli.com    Email : jainboardingsangli@gmail.com \n',
                    style: 'header3',
                  },
                ],
              },
              {
                style: 'logo',
                width: '15%',
                image: logo2Base64,
                fit: [50, 50],
              },
            ],
          },
          {
            margin: [0, 15, 0, 0],
            canvas: [
              {
                type: 'line',
                x1: 0,
                y1: 0,
                x2: 515,
                y2: 0,
                lineWidth: 1,
              },
            ],
          },
          {
            text: `Form Date : ${adminData.createdAt}`,
            style: 'formDate',
            alignment: 'right',
          },
          {
            text: 'Admission Application',
            style: 'title',
            alignment: 'center',
            margin: [0, 8, 0, 0],
          },
          {
            text: `Form No. : ${data.reg_id}`,
            style: 'formNo',
            alignment: 'left',
            margin: [0, -15, 0, 0],
          },
          {
            text: "Hon'ble Secretary/Superintendent",
            style: 'subheader',
            margin: [0, 15, 0, 0],
          },
          {
            text: `Sheth R D Dawada Digambar Jain Boarding, Sangli
          I, the undersigned, request you to grant me admission in 'Sangli Jain Boarding'.
          I have read the Boarding & Mess rules, agree to them and will strictly follow them .`,
            style: 'text',
          },
          {
            columns: [
              {
                width: '*',
                text: '',
              },
              {
                width: 'auto',
                stack: [
                  {
                    text: '',
                    style: 'photo',
                    alignment: 'center',
                    margin: [0, -10, 0, 0],
                  },
                  {
                    image: studentStaticBase64,
                    width: 80,
                    height: 85,
                    border: [true, true, true, true],
                    borderColor: 'gray',
                    border: '2px solid',
                    margin: [0, -60, 0, 0],
                  },
                ],
              },
            ],
          },
          {
            table: {
              widths: ['*'],
              body: [
                [
                  {
                    text: 'Personal Information',
                    style: 'tableHeader',
                    alignment: 'center',
                  },
                ],
                [
                  {
                    stack: [
                      {
                        text: [
                          {
                            text: "Student's Full Name: ",
                            bold: true,
                            style: 'text',
                          },
                          { text: `${data.name}\n`, style: 'text' },
                          {
                            text: "Father's Full Name: ",
                            bold: true,
                            style: 'text',
                          },
                          { text: `${data.fatherName}\n`, style: 'text' },
                          { text: 'Address: ', bold: true, style: 'text' },
                          { text: `${data.address}\n`, style: 'text' },
                          {
                            text: 'Have you any major medical issues ?: ',
                            bold: true,
                            style: 'text',
                          },
                          {
                            text: `${data.medicalIssue_flag}\n`,
                            style: 'text',
                          },
                          {
                            text: 'Description :  ',
                            bold: true,
                            style: 'text',
                          },
                          {
                            text: `${data.medicalIssue_description}\n`,
                            style: 'text',
                          },
                          {
                            text: 'Have you any disability ?: ',
                            bold: true,
                            style: 'text',
                          },
                          { text: `${data.disability_flag} \n`, style: 'text' },
                          {
                            text: 'Description :  ',
                            bold: true,
                            style: 'text',
                          },
                          {
                            text: `${data.disability_description}\n`,
                            style: 'text',
                          },
                        ],
                        lineHeight: 1.3,
                      },
                      {
                        columns: [
                          {
                            width: '50%',
                            stack: [
                              {
                                text: [
                                  {
                                    text: 'Adhar No.: ',
                                    bold: true,
                                    style: 'text',
                                  },
                                  { text: `${data.adharNo}\n`, style: 'text' },
                                  {
                                    text: 'Contact No.: ',
                                    bold: true,
                                    style: 'text',
                                  },
                                  { text: `${data.mob_no}\n`, style: 'text' },
                                  {
                                    text: "Parent's Contact No.: ",
                                    bold: true,
                                    style: 'text',
                                  },
                                  {
                                    text: `${data.parents_mobno}\n`,
                                    style: 'text',
                                  },
                                  {
                                    text: 'Birthdate: ',
                                    bold: true,
                                    style: 'text',
                                  },
                                  {
                                    text: `${data.dateofbirth}\n`,
                                    style: 'text',
                                  },
                                  {
                                    text: 'Blood Group: ',
                                    bold: true,
                                    style: 'text',
                                  },
                                  {
                                    text: `${data.blood_group}\n`,
                                    style: 'text',
                                  },
                                ],
                                lineHeight: 1.3,
                              },
                            ],
                          },
                          {
                            width: '50%',
                            stack: [
                              {
                                text: [
                                  { text: 'Age: ', bold: true, style: 'text' },
                                  {
                                    text: `${data.age} ${
                                      data.age ? 'Yrs' : ''
                                    }\n`,
                                    style: 'text',
                                  },
                                  {
                                    text: "Student's Sub-Cast: ",
                                    bold: true,
                                    style: 'text',
                                  },
                                  {
                                    text: `${data.sub_category}\n`,
                                    style: 'text',
                                  },
                                  {
                                    text: "Father's Occupation: ",
                                    bold: true,
                                    style: 'text',
                                  },
                                  {
                                    text: `${data.father_occupation}\n`,
                                    style: 'text',
                                  },
                                  {
                                    text: 'Email Id: ',
                                    bold: true,
                                    style: 'text',
                                  },
                                  { text: `${data.email}\n`, style: 'text' },
                                ],
                                lineHeight: 1.4,
                              },
                            ],
                          },
                        ],
                      },
                    ],
                    margin: [0, 7, 0, 0],
                  },
                ],
              ],
            },
            layout: 'noBorders',
            margin: [0, 8, 0, 0],
          },
          {
            table: {
              widths: ['*'],
              body: [
                [
                  {
                    text: 'Educational Information',
                    style: 'tableHeader',
                    alignment: 'center',
                  },
                ],
                [
                  {
                    text: [
                      {
                        text: 'Last year School/college Name: ',
                        bold: true,
                        style: 'text',
                      },
                      { text: `${data.l_collagename}\n`, style: 'text' },
                      {
                        text: 'Standard and Division: ',
                        bold: true,
                        style: 'text',
                      },
                      { text: `${data.std}\n`, style: 'text' },
                      {
                        text: 'Current School/College Name: ',
                        bold: true,
                        style: 'text',
                      },
                      { text: `${data.collage_name}\n`, style: 'text' },
                      {
                        text: 'Current Standard and Division: ',
                        bold: true,
                        style: 'text',
                      },
                      { text: `${data.nextyearcollagename}\n`, style: 'text' },
                      {
                        text:
                          'Did you stay in Sangli Jain Boarding last year?: ',
                        bold: true,
                        style: 'text',
                      },
                      { text: `${data.profeciency}\n`, style: 'text' },
                      {
                        text:
                          "Have you received a Dakshin Bharat Jain Sabha's Scholarship ?: ",
                        bold: true,
                        style: 'text',
                      },
                      { text: `${data.fellowship}\n`, style: 'text' },
                    ],
                    margin: [0, 7, 0, 0],
                    lineHeight: 1.4,
                  },
                ],
              ],
            },
            layout: 'noBorders',
            margin: [0, 8, 0, 0],
          },

          // Full-width table header
          {
            table: {
              widths: ['*'],
              body: [
                [
                  {
                    text: 'Document Uploaded',
                    style: 'tableHeader',
                    alignment: 'center',
                  },
                ],
              ],
            },
            layout: 'noBorders',
            margin: [0, 8, 0, 0],
          },

          // Two-column layout: document info + father's image
          {
            columns: [
              {
                width: '80%',
                text: [
                  { text: "Student's Aadhar Card: ", bold: true },
                  { text: 'Yes\n' },
                  {
                    text: "Student's School Leaving Certificate: ",
                    bold: true,
                  },
                  { text: 'Yes\n' },
                  {
                    text: 'Current Year School Admission Receipt: ',
                    bold: true,
                  },
                  { text: 'Yes\n' },
                ],
                margin: [0, 7, 0, 0],
                lineHeight: 1.3,
                style: 'text',
              },
              {
                width: '20%',
                stack: [
                  {
                    text: "Parent's Photo",
                    style: 'photo',
                    alignment: 'center',
                    margin: [0, 0, -10, 5],
                  },
                  {
                    image: parentStaticBase64, // Replace with actual base64 image
                    width: 80,
                    height: 85,
                    alignment: 'center',
                    margin: [0, 5, -10, 0],
                  },
                ],
              },
            ],
            margin: [0, 0, 0, 10],
          },
          { text: 'Date:', margin: [0, 20, 0, 0] },
          {
            text: "Student's signature",
            alignment: 'center',
            margin: [0, -14, 0, 0],
          },
          {
            text: "Parent's signature",
            alignment: 'right',
            margin: [0, -14, 0, 0],
          },
        ],
        styles: {
          header: {
            fontSize: 15,
            alignment: 'center',
            bold: true,
          },
          formDate: {
            fontSize: 11,
            bold: true,
          },
          text: {
            fontSize: 10,
          },
          formNo: {
            fontSize: 10,
            bold: true,
          },
          header1: {
            fontSize: 12,
            alignment: 'center',
          },
          header2: {
            fontSize: 11,
            alignment: 'center',
          },
          header3: {
            fontSize: 9,
            alignment: 'center',
          },
          logo: {
            alignment: 'center',
          },
          photo: {
            border: '1px solid black',
            height: 100,
            width: 100,
          },
          subheader: { fontSize: 12, bold: true },
          title: { fontSize: 14, bold: true },
          tableHeader: {
            fontSize: 12,
            bold: true,
            fillColor: '#a2d6f8',
            color: 'black',
          },
        },
      }

      pdfMake.createPdf(documentDefinition).open()

      toast.dismiss(pdfToastId)
      toast.success('PDF generated successfully!')
      // navigate('/');
    } catch (err) {
      toast.dismiss('pdf-wait')
      throw err
    }
  }

  const handleDeleteConfirmation = (id) => {
    if (!checkBoxChecked) {
      alert('Please select the checkbox before proceeding.')
      return
    }
    setRowToDelete(id)
    setDialogOpen(true)
    setOpen(false)
  }

  const handleStatusModalOpen = (row, button) => {
    setStatusRow(row)
    handleViewClick(row)
    setButtonFlag(button)
    setStatusModalOpen(true)
    setOpen(false)
  }

  const data = {
    columns: [
      { label: 'Reg_ID', field: 'reg_id' },
      { label: 'Name', field: 'Name', width: 150 },
      { label: 'Mobile No', field: 'mob_no' },
      {
        label: 'View',
        field: 'View',
        render: (row) => (
          <Button
            variant="contained"
            color="primary"
            onClick={() => generatePDF(row.reg_id)}
            style={{ fontSize: '12px' }}
          >
            <span className="me-1">View Pdf</span>{' '}
            <i class="fa-regular fa-eye"></i>
          </Button>
        ),
      },
      {
        label: 'Status',
        field: 'Status',
        render: (row) => {
          if (row.regform_approval === '0') {
            return (
              <Button
                variant="contained"
                style={{
                  backgroundColor: 'orange',
                  color: 'white',
                  fontSize: '12px',
                }}
                onClick={() => handleStatusModalOpen(row, 1)}
              >
                <span className="me-1">Pending</span>{' '}
                <i class="fas fa-spinner"></i>
              </Button>
            )
          } else if (row.regform_approval === '1') {
            return (
              <Button
                variant="contained"
                style={{
                  backgroundColor: 'green',
                  color: 'white',
                  fontSize: '12px',
                }}
                // disabled
                onClick={() => handleStatusModalOpen(row, 2)}
              >
                <span className="me-1">Approved</span>{' '}
                <i class="fas fa-check"></i>
              </Button>
            )
          } else {
            return (
              <Button
                variant="contained"
                style={{
                  backgroundColor: 'red',
                  color: 'white',
                  fontSize: '12px',
                }}
                // disabled
                onClick={() => handleStatusModalOpen(row, 2)}
              >
                <span className="me-1">Rejected</span>{' '}
                <i class="fas fa-times"></i>
              </Button>
            )
          }
        },
      },
    ],
    rows: rows.map((row) => ({
      ...row,
      View: (
        <Button
          variant="contained"
          color="primary"
          onClick={() => generatePDF(row.reg_id)}
          style={{ fontSize: '12px' }}
        >
          <span className="me-1">View Pdf</span>{' '}
          <i class="fa-regular fa-eye"></i>
        </Button>
      ),
      Status:
        row.regform_approval === '0' ? (
          <>
            {(flag == 1 || flag == 3 || flag == 4) && (
              <Button
                variant="contained"
                color="primary"
                onClick={() => handleStatusModalOpen(row, 1)}
                style={{
                  backgroundColor: 'orange',
                  color: 'white',
                  fontSize: '12px',
                }}
              >
                <span className="me-1">Pending</span>{' '}
                <i class="fas fa-spinner"></i>
              </Button>
            )}
          </>
        ) : row.regform_approval === '1' ? (
          <Button
            variant="contained"
            style={{
              backgroundColor: 'green',
              color: 'white',
              fontSize: '12px',
            }}
            // disabled
            onClick={() => handleStatusModalOpen(row, 2)}
          >
            <span className="me-1">Approved</span> <i class="fas fa-check"></i>
          </Button>
        ) : (
          <Button
            variant="contained"
            style={{ backgroundColor: 'red', color: 'white', fontSize: '12px' }}
            // disabled
            onClick={() => handleStatusModalOpen(row, 2)}
          >
            <span className="me-1">Rejected</span> <i class="fas fa-times"></i>
          </Button>
        ),
    })),
  }

  return (
    <>
      <div
        className="roomchange-container"
        style={{ display: 'flex', minHeight: '100vh' }}
      >
        {/* Sidebar on the left for desktop */}
        <div
          className="d-none d-md-block sidebar-container"
          style={{ width: '270px', flexShrink: 0 }}
        >
          <Sidebar />
        </div>

        {/* Main content on the right */}
        <div
          className="main-content flex-grow-1"
          style={{ flex: 1, backgroundColor: '#f8f9fa' }}
        >
          <NavLogo />

          <div className="d-block d-md-none">
            <MobileNavbarAdmin />
          </div>
          <div
            className="border w-100 h-100 py-3"
            style={{ backgroundColor: '#f5f5f5ff' }}
          >
            <div className="row m-0 block-header ps-3">
              <h5
                className="room-change-title text-start mt-md-4 mt-2"
                style={{ color: '#0783d6' }}
              >
                Application Form Approval
              </h5>
            </div>

            <Row
              className="m-0 p-0 px-md-3 py-1 pb-5 mb-5 mt-4 w-100"
              style={{ display: 'flex' }}
            >
              <Col
                className="m-0 p-0 px-3 py-3 rounded shadow"
                style={{ background: 'white' }}
              >
                <div style={{ overflowY: 'auto' }}>
                  <div style={{ overflowX: 'auto' }}>
                    <MDBDataTable
                      striped
                      className="custom-datatable text-center"
                      bordered
                      hover
                      small
                      data={data}
                    />
                  </div>
                </div>
              </Col>
            </Row>

            <Modal
              open={open}
              onClose={() => setOpen(false)}
              aria-labelledby="status-modal-title"
              aria-describedby="status-modal-description"
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <Box
                sx={{
                  position: 'relative',
                  width: '700px',
                  maxHeight: '90vh',
                  overflow: 'scroll',
                  backgroundColor: '#fff',
                  borderRadius: '10px',
                  boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)',
                  display: 'flex',
                  flexDirection: 'column',
                }}
              >
                <Box
                  sx={{
                    overflowY: 'auto',
                    overflowY: 'scroll',
                    p: 4,
                    flex: 1,
                  }}
                >
                  <Typography
                    id="modal-modal-description"
                    style={{ lineHeight: '18px' }}
                  >
                    <div className="block-header">
                      <h2
                        className="mb-3"
                        style={{
                          color: 'maroon',
                          borderBottom: '2px solid maroon',
                        }}
                      >
                        Application Form
                      </h2>
                    </div>
                    <Row>
                      <Col>
                        {' '}
                        <b>Name</b>:
                      </Col>
                      <Col> {selectedRow.name} </Col>
                    </Row>
                    <br />
                    <Row>
                      <Col>
                        <b>Address</b>:
                      </Col>
                      <Col>{selectedRow.address}</Col>
                    </Row>
                    <br />
                    <Row>
                      <Col>
                        <b>Mobile No.</b>:
                      </Col>
                      <Col>{selectedRow.mob_no} </Col>
                    </Row>
                    <br />
                    <Row>
                      <Col>
                        <b>Amount Paid Rs</b>:
                      </Col>
                      <Col>{selectedRow.payment_amount}</Col>
                    </Row>
                    <br />
                    <Row>
                      <Col>
                        <b>Pay Mode</b>:
                      </Col>
                      <Col>{selectedRow.pay_mode}</Col>
                    </Row>
                    <br />
                    <Row>
                      <Col>
                        <b>Transaction Id</b>:{' '}
                      </Col>
                      <Col>{selectedRow.taxId} </Col>
                    </Row>
                    <br />
                    <Row style={{ display: 'flex' }}>
                      <Col>
                        <b>Transaction Image</b>:{' '}
                      </Col>
                      <Row>
                        <Col md={3}></Col>
                        <Col className=" mt-2 text-center" md={6}>
                          <img
                            src={`${ImagePath}/${selectedRow.tax_image}`}
                            className="acceptable rounded shadow border-0"
                            alt=""
                            style={{
                              height: '16rem',
                              width: '15rem',
                              border: '1px solid grey',
                            }}
                          />
                        </Col>
                        <Col md={3}></Col>
                      </Row>
                    </Row>
                  </Typography>
                </Box>
                <Box
                  sx={{
                    p: 2,
                    borderTop: '1px solid #ccc',
                    textAlign: 'right',
                  }}
                >
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={() => setOpen(false)}
                  >
                    Close
                  </Button>
                </Box>
              </Box>
            </Modal>

            <Dialog open={dialogOpen} onClose={() => setDialogOpen(false)}>
              <DialogTitle>{'Reject Student'}</DialogTitle>
              <DialogContent>
                <DialogContentText>
                  Do you really want to reject the student?
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button onClick={() => setDialogOpen(false)} color="primary">
                  Cancel
                </Button>
                <Button
                  onClick={() => handleDelete(rowToDelete)}
                  color="primary"
                  autoFocus
                >
                  Confirm
                </Button>
              </DialogActions>
            </Dialog>

            <Modal
              open={statusModalOpen}
              onClose={() => setStatusModalOpen(false)}
              aria-labelledby="status-modal-title"
              aria-describedby="status-modal-description"
              sx={{
                display: 'flex',
                overflow: 'scroll',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <Box
                sx={{
                  position: 'relative',
                  width: '700px',
                  maxHeight: '90vh',
                  overflow: 'scroll',
                  backgroundColor: '#fff',
                  borderRadius: '10px',
                  boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)',
                  display: 'flex',
                  flexDirection: 'column',
                }}
              >
                <Box
                  sx={{
                    p: 3,
                    borderTop: '1px solid #ccc',
                    // textAlign: 'right',
                  }}
                >
                  <Row>
                    <div className="block-header">
                      <h2
                        className="mb-2  mt-1 "
                        style={{
                          color: 'maroon',
                          borderBottom: '2px solid maroon',
                        }}
                      >
                        Application Form
                      </h2>
                    </div>

                    <Box
                      sx={{
                        overflowY: 'auto',
                        p: 4,
                        flex: 1,
                      }}
                    >
                      <Typography
                        id="modal-modal-description"
                        style={{ lineHeight: '18px' }}
                      >
                        <Row>
                          <Col>
                            {' '}
                            <b>Name</b>:
                          </Col>
                          <Col> {selectedRow.name} </Col>
                        </Row>
                        <br />
                        <Row>
                          <Col>
                            <b>Address</b>:
                          </Col>
                          <Col>{selectedRow.address}</Col>
                        </Row>
                        <br />
                        <Row>
                          <Col>
                            <b>Mobile No.</b>:
                          </Col>
                          <Col>{selectedRow.mob_no} </Col>
                        </Row>
                        <br />
                        <Row>
                          <Col>
                            <b>Amount Paid Rs </b>:
                          </Col>
                          <Col>{selectedRow.payment_amount}</Col>
                        </Row>
                        <br />
                        <Row>
                          <Col>
                            <b>Pay Mode</b>:
                          </Col>
                          <Col>{selectedRow.pay_mode}</Col>
                        </Row>
                        <br />
                        <Row>
                          <Col>
                            <b>Transaction Id</b>:{' '}
                          </Col>
                          <Col>{selectedRow.taxId} </Col>
                        </Row>
                        <br />
                        <Row style={{ display: 'flex' }}>
                          <Col>
                            <b>Transaction Image</b>:{' '}
                          </Col>
                          <Col className=" mt-3 text-center" md={6} xs={12}>
                            <img
                              src={`${ImagePath}/${selectedRow.tax_image}`}
                              className="acceptable rounded shadow border-0 "
                              alt=""
                              style={{
                                height: '16rem',
                                width: '15rem',
                                border: '1px solid grey',
                              }}
                            />
                          </Col>
                        </Row>
                      </Typography>
                    </Box>

                    {buttonFlag == 1 && (
                      <>
                        <Box
                          sx={{
                            p: 2,
                          }}
                        >
                          <Checkbox
                            className="ps-0 m-0"
                            style={{ position: 'relative' }}
                            checked={checkBoxChecked}
                            onChange={handleCheckBoxChange}
                          />{' '}
                          <b>Check And Proceed..</b>
                          <Row className="mt-1" style={{ display: 'flex' }}>
                            <Col>
                              <Button
                                variant="contained"
                                color="primary"
                                className="w-100"
                                onClick={() =>
                                  handleApproval(statusRow?.reg_id)
                                }
                                style={{ marginRight: '10px' }}
                              >
                                Approve
                              </Button>
                            </Col>
                            <Col>
                              <Button
                                variant="contained"
                                className="w-100"
                                color="secondary"
                                onClick={() =>
                                  handleDeleteConfirmation(statusRow?.reg_id)
                                }
                              >
                                Reject
                              </Button>
                            </Col>
                          </Row>
                        </Box>
                      </>
                    )}
                  </Row>
                </Box>
                <Box
                  sx={{
                    p: 2,
                    borderTop: '1px solid #ccc',
                    textAlign: 'right',
                  }}
                >
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={() => {
                      setStatusModalOpen(false)
                      setButtonFlag('')
                    }}
                  >
                    Close
                  </Button>
                </Box>
              </Box>
            </Modal>
          </div>
        </div>
      </div>
    </>
  )
}
